import api from './api';

/** CRF-page Reviewer's Comment (DCF) — calls `api/dcf/*` (not Report Review `dcfService.js`). */
const crfDcfService = {
  raise: (body) => api.post('/dcf/raise', body),
  submitAllToCra: (nCRFHdrNo) => api.post(`/dcf/page/${nCRFHdrNo}/submit-all`, {}),
  /** @param {{ vDCFResponse?: string|null, vRemarks?: string|null, finalizeResolve: boolean, viewingStage?: string|null }} body */
  resolve: (nCRFDtlNo, body) => api.post(`/dcf/${nCRFDtlNo}/resolve`, body),
  close: (nCRFDtlNo, body) => api.post(`/dcf/${nCRFDtlNo}/close`, body ?? {}),
  history: (nCRFDtlNo) => api.get(`/dcf/${nCRFDtlNo}/history`),
  pageState: (nCRFHdrNo) => api.get(`/dcf/page/${nCRFHdrNo}/state`),
};

export default crfDcfService;
